<template>
  <div v-if="!booted" class="flex h-screen items-center justify-center bg-slate-50">
    <div class="flex flex-col items-center gap-3">
      <div class="flex h-12 w-12 items-center justify-center rounded-2xl bg-brand-gradient shadow-glow">
        <svg viewBox="0 0 24 24" class="h-6 w-6 text-white" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M3 21h18M5 21V7l7-4 7 4v14M9 21v-6h6v6" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
      <div class="h-1 w-24 overflow-hidden rounded-full bg-slate-200">
        <div class="h-full w-1/2 animate-pulse rounded-full bg-brand-500" />
      </div>
    </div>
  </div>
  <router-view v-else />
</template>

<script setup>
import { ref, onMounted } from "vue"
import { fetchContext } from "@/data/session"

const booted = ref(false)

onMounted(async () => {
  await fetchContext()
  booted.value = true
})
</script>
